function getNowTimeHmss() {
    var date = new Date();
    var h = ("00" + date.getHours()).slice(-2);
    var m = ("00" + date.getMinutes()).slice(-2);
    var s = ("00" + date.getSeconds()).slice(-2);
    var sss = ("000" + date.getMilliseconds()).slice(-3);
    return h + ":" + m + ":" + s + "." + sss;
}

export { getNowTimeHmss }
